import React, { useState, useEffect, useContext } from "react";
import { Context } from '../../../context/UserContext'
import { IoIosClose } from "react-icons/io";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useForm } from "react-hook-form";
import ReverseService from "../../../services/ReverseService";
import CollectOrderService from "../../../services/CollectOrderService";
import TiposColeta from "../../../enums/TiposColeta";
import SgsService from "../../../services/SgsService";
import { ehUsuarioInterno } from "../../../utils/roles";

export default function InitiateReverseModal({
  isModalOpen,
  setModalOpen,
  reverseId,
  requestNro
  // setTicketCb
}) {
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
    setValue,
  } = useForm();

  const [reverseObject, setReverseObject] = useState();

  const [searchResults, setSearchResults] = useState([]);
  const [selectedItem, setSelectedItem] = useState(null);
  const [showDevicesList, setShowDevicesList] = useState(false)

  const [ devolverOutro, setDevolverOutro] = useState(false);

  const { user } = useContext(Context)
  
  const filteredTiposColeta = (user.role !== 'vivogestao' && !ehUsuarioInterno(user))
    ? TiposColeta.filter(tipo => !["08", "12", "14"].includes(tipo.cod))
    : TiposColeta;

  const [qtdColetaValue, setQtdColetaValue] = useState(0);
  const [tiposDefeitos, setTiposDefeitos] = useState([]);

  useEffect(() => {
    async function fetchRequest() {
      const reverse = await ReverseService.getReverseById(reverseId);
      setReverseObject(reverse);
    }

    fetchRequest();

    setValue("codEquipamentoColeta", reverseObject?.reverse.request?.codSap);
    setValue("nomeEquipamentoColeta", reverseObject?.reverse.request?.nomeEquipamento);
    setValue('fabricanteEquipamentoColeta', reverseObject?.reverse.request?.fabricanteEquipamento)
    setValue('partNumberEquipamentoColeta', reverseObject?.reverse.request?.partNumberEquipamento)
    setValue('familiaEquipamentoColeta', reverseObject?.reverse.request?.familiaEquipamento)
    setValue('grupoProdutoEquipamentoColeta', reverseObject?.reverse.request?.grupoProdutoEquipamento)
    setValue("enderecoColeta", reverseObject?.reverse.enderecoColeta);
    setValue("enderecoColetaComplemento", reverseObject?.reverse.enderecoColetaComplemento);
    setValue("nomeSolicitante", reverseObject?.reverse.request.tecnico);
    setValue("contatoSolicitante", reverseObject?.reverse.request.telefone);
    setValue("idRequest", reverseObject?.reverse.request?.idRequest);
    setValue("gmo", reverseObject?.reverse.gmo._id);
  }, [isModalOpen, reverseId, reverseObject?.reverse.enderecoColeta, reverseObject?.reverse.enderecoColetaComplemento, reverseObject?.reverse.gmo._id, reverseObject?.reverse.request?.codSap, reverseObject?.reverse.request?.fabricanteEquipamento, reverseObject?.reverse.request?.familiaEquipamento, reverseObject?.reverse.request?.grupoProdutoEquipamento, reverseObject?.reverse.request?.idRequest, reverseObject?.reverse.request?.nomeEquipamento, reverseObject?.reverse.request?.partNumberEquipamento, reverseObject?.reverse.request.tecnico, reverseObject?.reverse.request.telefone, reverseObject?.reverse.user.name, reverseObject?.reverse.user.phone, setValue]);

  useEffect(() => {
    if (isModalOpen) {
      SgsService.getDefeitos().then((result) => {
        if (result) setTiposDefeitos(result);
      });
    }
  }, [isModalOpen]);

  const handleDevolverOutro = (event) => {
    setDevolverOutro(event.target.checked);
  };



  const handleInputChange = async (e) => {
    setShowDevicesList(true)
    const searchTerm = e.target.value;
    if (searchTerm.length >= 3) {
      try {
        const data = await SgsService.getSgsItems(`?name=${searchTerm}`);
        setSearchResults(data.result.data);
        console.log(data.result.data)
      } catch (error) {
        console.error('Error fetching search results:', error);
      }
    } else {
      setSearchResults([]);
    }
  };

  const handleSelectItem = (item) => {
    setSelectedItem(item);
    // setValue('codSap', item.codigo);
    setValue('nomeEquipamentoDevolucao', item.nome);
    // setValue('partNumberEquipamento', item.partNumber)
    // setValue('fabricanteEquipamento', item.nomeFabricante)
    setShowDevicesList(false)
    // console.log(item)
    // Execute your action here
  };


  const onSubmit = async (data) => {
    // Mapeia os serials para incluir nameDefeito
    const serials = (data.serials || []).map((item) => {
      let idDefeito = '';
      let nameDefeito = '';
      if (item.defeito) {
        try {
          const parsed = JSON.parse(item.defeito);
          idDefeito = parsed.idDefeito;
          nameDefeito = parsed.nameDefeito;
        } catch { }
      }
      return {
        serial: item.serial,
        idDefeito,
        nameDefeito,
      };
    });

    const payload = {
      ...data,
      serials
    };

    try {
      await CollectOrderService.createCollectOrder(payload, reverseObject.reverse._id);
      toast.success("Ordem de Coleta gerada!");
    } catch (error) {
      toast.error(error.message);
    }

    setModalOpen(!isModalOpen);
    reset();
  };

  const onClose = () => {
    setModalOpen(!isModalOpen);
    reset();
  };

  if (isModalOpen) {
    return (
      <div
        className="flex flex-col relative z-10"
        aria-labelledby="modal-title"
        role="dialog"
        aria-modal="true"
      >
        <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"></div>

        <div className="fixed inset-0 z-10 w-screen overflow-y-auto"
          onClick={onClose}
        >
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <div className="flex flex-col w-[648px] h-fit pb-2 relative transform rounded-lg bg-white text-left shadow-xl transition-all mt-2" onClick={(e) => e.stopPropagation()}>
              <button
                onClick={onClose}
                className="absolute -top-7 -right-7 rounded-full p-1"
              >
                <div className="w-12 h-12 flex bg-gray-200 justify-center items-center rounded-full ms-6">
                  <div className="flex justify-center items-center">
                    <IoIosClose color={"black"} size={32} />
                  </div>
                </div>
              </button>
              <div className="flex flex-col px-4 text-left bg-gray-800 rounded-t-lg">
                <div className="text-white text-xl font-bold mt-4 mb-1">
                  INICIAR PROCESSO DE COLETA
                </div>
                <div className="text-white text-xs font-normal mb-1 flex items-center gap-1">
                  Referente à Solicitação nº:
                  <input
                    disabled={true}
                    type="text"
                    {...register("idRequest", { required: true })}
                    className="bg-transparent text-yellow-500 text-sm font-bold px-1 py-1 w-24 border-none outline-none"
                  />
                </div>
              </div>
              <div className="flex flex-col gap-2 mt-2 mx-2 text-[11px]">
                {/* DIV Usuario */}
                <div className="flex flex-col pt-4 px-4 bg-gray-50 border rounded-md relative">
                  <div className="absolute right-4 top-2 text-blue-400 font-bold">
                    <a href="#">Ver mais</a>
                  </div>

                  <div className="flex flex-row gap-8 w-full">
                    <div className="flex items-start gap-1 mb-4">
                      <label className="block text-gray-700 font-bold whitespace-nowrap">
                        Nome Solicitante:
                      </label>
                      <div>
                        {reverseObject?.reverse.request?.nomeSolicitante}
                      </div>
                    </div>
                    <div className="flex items-start gap-1 mb-4">
                      <label className="block text-gray-700 font-bold whitespace-nowrap">
                        RE/Legal Solicitante:
                      </label>
                      <div>
                        {reverseObject?.reverse.request?.reLegalSolicitante}
                      </div>
                    </div>
                    <div className="flex items-start gap-1 mb-4">
                      <label className="block text-gray-700 font-bold whitespace-nowrap">
                        UF:
                      </label>
                      <div>{reverseObject?.reverse.request?.uf}</div>
                    </div>
                  </div>
                </div>

                {/* DIV Equipamento */}
                {/* <div className="flex flex-col pt-4 px-4 bg-gray-50 border rounded-md relative text-xs">
                  <div className="flex flex-row gap-8 w-full">
                    <div className="flex items-start gap-1 mb-4 whitespace-nowrap">
                      <label className="block text-gray-700 font-bold">
                        Cod. Sap:
                      </label>
                      <div>{reverseObject?.reverse.request?.codSap}</div>
                    </div>
                    <div className="flex items-start gap-1 mb-4 w-full">
                      <label className="block text-gray-700 font-bold whitespace-nowrap">
                        Quantidade solicitada:
                      </label>
                      <div>
                        {reverseObject?.reverse.request?.quantidadeAtender}
                      </div>
                    </div>
                  </div>
                  <div className="flex items-start gap-1 mb-4 max-w-96">
                    <label className="block text-gray-700 font-bold">
                      Equipamento:
                    </label>
                    <div>
                      {reverseObject?.reverse.request?.nomeEquipamento}
                    </div>
                  </div>
                </div> */}

                {/* DIV Equipamento */}
                <div className="flex py-2 px-4 bg-gray-50 border rounded-md relative">
                  <div className="flex flex-col gap-3 w-full whitespace-nowrap">
                    <div className="flex gap-6">
                      <div className="flex items-start gap-1">
                        <label className="block text-gray-700 font-bold whitespace-nowrap">
                          Cod. Sap:
                        </label>
                        <div>{reverseObject?.reverse.request?.codSap}</div>
                      </div>

                      <div className="flex items-start gap-1">
                        <label className="block text-gray-700 font-bold">
                          Equipamento:
                        </label>
                        <div className="w-fit whitespace-break-spaces">{reverseObject?.reverse.request?.nomeEquipamento}</div>
                      </div>
                    </div>

                    <div className="flex gap-6">
                      <div className="flex items-start gap-1">
                        <label className="block text-gray-700 font-bold">
                          Fabricante:
                        </label>
                        <div>{reverseObject?.reverse.request?.fabricanteEquipamento}</div>
                      </div>
                      <div className="flex items-start justify-start gap-1 w-full">
                        <label className="block text-gray-700 font-bold whitespace-nowrap">
                          Quantidade Coleta:
                        </label>
                        <div>{reverseObject?.reverse.request?.quantidadeAtender}</div>
                      </div>
                    </div>
                  </div>
                </div>

              </div>

              {/* MODAL FORM BEGIN */}

              <div className="flex flex-col mt-2 px-3">
                <div className="w-full relative inline-block text-left">
                  <div className="w-full flex flex-col text-[11px] gap-4">
                    <div className="flex flex-col items-start gap-1 w-full">
                      <label className="w-1/5 block text-gray-700 font-bold whitespace-nowrap">
                        Tipo de Coleta:
                      </label>
                      <select
                        defaultValue="0"
                        {...register("tipoColeta", {
                          validate: (value) => {
                            return value !== "0";
                          },
                        })}
                        className={`block w-full rounded-2xl px-4 py-1 text-gray-900 shadow-sm placeholder:text-gray-400
                          ${
                            errors?.tipoColeta?.type === "validate"
                              ? " border border-red-500 outline-none ring-0"
                              : "border border-zinc-500 outline-none ring-0"
                          }
                          `}
                      >
                        <option value="0" disabled>
                          Selecione
                        </option>
                        {filteredTiposColeta.map((tipo, index) => (
                          <option key={index} value={tipo.cod}>
                            {tipo.cod} - {tipo.descricao}
                          </option>
                        ))}
                      </select>
                      {errors?.tipoColeta?.type === "validate" && (
                        <p className="text-red-500 text-xs whitespace-nowrap">
                          Tipo de Coleta é obrigatório
                        </p>
                      )}
                    </div>

                    <div className="flex flex-col gap-2 bg-gray-50 px-2 py-1 border rounded-md">
                      <div className="flex gap-2">

                        {/* <div className="flex flex-col items-start gap-1 w-full">
                          <label className="block text-gray-700 font-bold whitespace-nowrap">GMO:</label>
                          <input
                            disabled={true}
                            type="text"
                            {...register("gmo", { required: true })}
                            className={`block w-full rounded-2xl px-4 py-1 text-gray-900 shadow-sm placeholder:text-gray-400
                              ${
                                errors?.gmo?.type === "required" ?
                                " border border-red-500 outline-none ring-0" : "border border-zinc-500 outline-none ring-0"
                              }
                            `}
                          />
                          {errors?.gmo?.type === "required" && (
                            <p className="text-red-500 text-xs ms-2">
                              Campo obrigatório
                            </p>
                          )}
                        </div> */}

                        <div className="flex flex-col items-start gap-1 w-full">
                          <label className="block text-gray-700 font-bold whitespace-nowrap">Endereço para coleta:</label>
                          <input
                            // disabled={true}
                            type="text"
                            {...register("enderecoColeta", { required: true })}
                            className={`block w-full rounded-2xl px-4 py-1 text-gray-900 shadow-sm placeholder:text-gray-400
                              ${
                                errors?.enderecoColeta?.type === "required" ?
                                " border border-red-500 outline-none ring-0" : "border border-zinc-500 outline-none ring-0"
                              }
                            `}
                          />
                          {errors?.enderecoColeta?.type === "required" && (
                            <p className="text-red-500 text-xs ms-2">
                              Campo obrigatório
                            </p>
                          )}
                        </div>

                        <div className="flex flex-col items-start gap-1 w-4/6">
                          <label className="block text-gray-700 font-bold whitespace-nowrap">Complemento:</label>
                          <input
                            // disabled={true}
                            type="text"
                            {...register("enderecoColetaComplemento")}
                            className={`block w-full rounded-2xl px-4 py-1 text-gray-900 shadow-sm placeholder:text-gray-400
                              ${
                                errors?.enderecoColetaComplemento?.type === "required" ?
                                " border border-red-500 outline-none ring-0" : "border border-zinc-500 outline-none ring-0"
                              }
                            `}
                          />
                          {errors?.enderecoColetaComplemento?.type === "required" && (
                            <p className="text-red-500 text-xs ms-2">
                              Campo obrigatório
                            </p>
                          )}
                        </div>
                      </div>
                    </div>

                    <div className="flex flex-col gap-2 bg-gray-50 px-2 py-1 border rounded-md">
                      <div className="flex justify-between">
                        <label className="w-1/5 block text-gray-700 font-bold whitespace-nowrap">
                          Equipamento:
                        </label>

                        <div className="flex gap-2">
                          <label className="text-gray-700 text-xs whitespace-nowrap">
                            Devolver outro equipamento
                          </label>
                          <input
                            type="checkbox"
                            checked={devolverOutro}
                            onChange={handleDevolverOutro}
                            className="form-checkbox h-5 w-5 text-blue-600"
                          />
                        </div>
                      </div>

                      <div className="flex gap-2">

                        <div className="flex flex-col items-start gap-1 w-1/3">
                          <label className="block text-gray-700 whitespace-nowrap">Cod. SAP:</label>
                          <input
                            disabled={!devolverOutro}
                            type="text"
                            {...register("codEquipamentoColeta", { required: true })}
                            className={`block w-full rounded-2xl px-4 py-1 text-gray-900 shadow-sm placeholder:text-gray-400
                              ${
                                errors?.codEquipamentoColeta?.type === "required" ?
                                " border border-red-500 outline-none ring-0" : "border border-zinc-500 outline-none ring-0"
                              }
                            `}
                          />
                          {errors?.codEquipamentoColeta?.type === "required" && (
                            <p className="text-red-500 text-xs ms-2">
                              Campo obrigatório
                            </p>
                          )}
                        </div>

                        <div className="flex flex-col items-start gap-1 w-full">
                          <label className="block text-gray-700 whitespace-nowrap">Equipamento:</label>
                          <input
                            disabled={!devolverOutro}
                            type="text"
                            {...register("nomeEquipamentoColeta", { required: true })}
                            className={`block w-full rounded-2xl px-4 py-1 text-gray-900 shadow-sm placeholder:text-gray-400
                              ${
                                errors?.nomeEquipamentoColeta?.type === "required" ?
                                " border border-red-500 outline-none ring-0" : "border border-zinc-500 outline-none ring-0"
                              }
                            `}
                          />
                          {errors?.nomeEquipamentoColeta?.type === "required" && (
                            <p className="text-red-500 text-xs ms-2">
                              Campo obrigatório
                            </p>
                          )}
                        </div>

                      </div>

                      <div className="flex gap-2">
                        <div className="flex flex-col items-start gap-1 w-full">
                          <label className="block text-gray-700 whitespace-nowrap">Fabricante:</label>
                          <input
                            disabled={!devolverOutro}
                            type="text"
                            {...register("fabricanteEquipamentoColeta", { required: true })}
                            className={`block w-full rounded-2xl px-4 py-1 text-gray-900 shadow-sm placeholder:text-gray-400
                              ${
                                errors?.fabricanteEquipamentoColeta?.type === "required" ?
                                " border border-red-500 outline-none ring-0" : "border border-zinc-500 outline-none ring-0"
                              }
                            `}
                          />
                          {errors?.fabricanteEquipamentoColeta?.type === "required" && (
                            <p className="text-red-500 text-xs ms-2">
                              Campo obrigatório
                            </p>
                          )}
                        </div>
                        <div className="flex flex-col items-start gap-1 w-full">
                          <label className="block text-gray-700 whitespace-nowrap">Part Number:</label>
                          <input
                            disabled={!devolverOutro}
                            type="text"
                            {...register("partNumberEquipamentoColeta", { required: true })}
                            className={`block w-full rounded-2xl px-4 py-1 text-gray-900 shadow-sm placeholder:text-gray-400
                              ${
                                errors?.partNumberEquipamentoColeta?.type === "required" ?
                                " border border-red-500 outline-none ring-0" : "border border-zinc-500 outline-none ring-0"
                              }
                            `}
                          />
                          {errors?.partNumberEquipamentoColeta?.type === "required" && (
                            <p className="text-red-500 text-xs ms-2">
                              Campo obrigatório
                            </p>
                          )}
                        </div>

                      </div>

                      <div className="flex gap-2 w-full justify-between">
                      <div className="flex items-center gap-2">
                        <label className="block text-gray-700 font-bold whitespace-nowrap">
                          Quantidade informada para coleta:
                          </label>
                          <input
                            type="number"
                            max={reverseObject?.reverse?.quantidadeRestante || undefined}
                            {...register("qtdColeta", {
                              required: true,
                              validate: (value) => value > 0 && value <= reverseObject?.reverse?.quantidadeRestante,
                              onChange: (e) => setQtdColetaValue(Number(e.target.value)),
                            })}
                            className={`block w-20 rounded-2xl px-4 py-1 text-gray-900 shadow-sm placeholder:text-gray-400
                            ${errors?.qtdColeta
                                ? " border border-red-500 outline-none ring-0"
                                : "border border-zinc-500 outline-none ring-0"
                              }
                            `}
                          />
                        {errors?.qtdColeta?.type === "validate" && (
                          <p className="text-red-500 text-xs ms-2 w-32">
                            Deve ser maior que zero e menor que a quantidade restante
                          </p>
                        )}
                        </div>

                      <div className="flex items-center gap-2">
                        <label className="block text-gray-700 font-bold whitespace-nowrap">
                          Quantidade restante:
                        </label>
                        <div>{reverseObject?.reverse?.quantidadeRestante}</div>
                      </div>
                    </div>

                      {qtdColetaValue > 0 && (
                        <div className="flex flex-col gap-2 mt-2">
                          {[...Array(qtdColetaValue)].map((_, idx) => (
                            <div key={idx} className="flex gap-2 items-center">
                              <input
                                type="text"
                                {...register(`serials.${idx}.serial`)}
                                placeholder={`Serial ${idx + 1}`}
                                className="block rounded px-2 py-1 border border-zinc-300 text-xs"
                              />
                              <select
                                {...register(`serials.${idx}.defeito`)}
                                className="block rounded px-2 py-1 border border-zinc-300 text-xs"
                              >
                                <option value="">Tipo de Defeito</option>
                                {tiposDefeitos.data.map((defeito) => (
                                  <option
                                    key={defeito.id}
                                    value={JSON.stringify({ idDefeito: defeito.id, nameDefeito: defeito.name })}
                                  >
                                    {defeito.id} - {defeito.name}
                                  </option>
                                ))}
                              </select>
                            </div>
                          ))}
                        </div>
                      )}
                      
                    </div>

                    {/* {devolverOutro && (
                      <div className="flex flex-col items-start gap-1 w-full relative">
                        <label className="block text-gray-700 font-bold whitespace-nowrap">
                          Nome:
                        </label>
                        <input
                          type="text"
                          {...register("nomeEquipamentoDevolucao")}
                          placeholder="...digite ao menos 3 caracteres para buscar"
                          onChange={handleInputChange}
                          className={`block w-full rounded-2xl px-4 py-1 text-gray-900 shadow-sm placeholder:text-gray-400
                          ${
                            errors?.nomeEquipamentoDevolucao?.type ===
                            "required"
                              ? " border border-red-500 outline-none ring-0"
                              : "border border-zinc-500 outline-none ring-0"
                          }
                        `}
                        /> */}
                        {/* {!showDevicesList && 
                        <div className="ms-2 text-gray-400 italic flex gap-1 justify-center items-center">
                          <CiCircleInfo />
                          digite ao menos 3 caracteres para buscar
                        </div>} */}
                        {/* {searchResults?.length > 0 && showDevicesList && (
                          <div className="absolute w-full top-full left-0 mt-1 max-h-52 overflow-y-auto bg-white rounded shadow-lg border border-gray-200 z-20">
                            <ul>
                              {searchResults?.map((item) => (
                                <li
                                  key={item.codigo}
                                  onClick={() => handleSelectItem(item)}
                                  className="px-4 py-2 cursor-pointer hover:bg-gray-100"
                                >
                                  {item.nome}
                                </li>
                              ))}
                            </ul>
                          </div>
                        )}
                      </div>
                    )} */}

                    <div className="flex flex-col gap-2 bg-gray-50 px-2 py-1 border rounded-md">
                      <div className="flex gap-2">
                        <div className="flex flex-col items-start gap-1 w-full">
                          <label className="block text-gray-700 font-bold whitespace-nowrap">Solicitante:</label>
                          <input
                            // disabled={true}
                            type="text"
                            {...register("nomeSolicitante", { required: true })}
                            className={`block w-full rounded-2xl px-4 py-1 text-gray-900 shadow-sm placeholder:text-gray-400
                              ${
                                errors?.nomeSolicitante?.type === "required" ?
                                " border border-red-500 outline-none ring-0" : "border border-zinc-500 outline-none ring-0"
                              }
                            `}
                          />
                          {errors?.nomeSolicitante?.type === "required" && (
                            <p className="text-red-500 text-xs ms-2">
                              Campo obrigatório
                            </p>
                          )}
                        </div>

                        <div className="flex flex-col items-start gap-1 w-4/6">
                          <label className="block text-gray-700 font-bold whitespace-nowrap">Contato:</label>
                          <input
                            // disabled={true}
                            type="text"
                            {...register("contatoSolicitante", { required: true })}
                            className={`block w-full rounded-2xl px-4 py-1 text-gray-900 shadow-sm placeholder:text-gray-400
                              ${
                                errors?.contatoSolicitante?.type === "required" ?
                                " border border-red-500 outline-none ring-0" : "border border-zinc-500 outline-none ring-0"
                              }
                            `}
                          />
                          {errors?.contatoSolicitante?.type === "required" && (
                            <p className="text-red-500 text-xs ms-2">
                              Campo obrigatório
                            </p>
                          )}
                        </div>
                      </div>
                    </div>

                    <div className="flex flex-col items-start gap-1 mb-4 w-full">
                      <label className="w-1/5 block text-gray-700 font-bold whitespace-nowrap">
                        Observação da Coleta:
                      </label>
                      <textarea
                        {...register("observacaoColeta", {
                          // required: true,
                        })}
                        className={`
                              w-full h-[80px] p-4 bg-white rounded-lg justify-start items-center inline-flex resize-none 
                              text-gray-600 text-sm font-normal font-['Work Sans']
                              focus:border focus:border-zinc-800 focus:outline-none focus:ring-0
                              placeholder:text-gray-400 placeholder:text-sm placeholder:font-normal placeholder:font-['Work Sans'] placeholder:leading-[14.34px]
                              ${
                                errors?.observacaoColeta?.type === "required"
                                  ? "border border-red-500 outline-none ring-0"
                                  : "border border-zinc-500 outline-none ring-0"
                              }
                          `}
                        placeholder={"Observação do Antedimento"}
                      ></textarea>
                      {errors?.observacaoColeta?.type === "required" && (
                        <p className="text-red-500 text-xs whitespace-nowrap">
                          Campo obrigatório
                        </p>
                      )}
                    </div>

                    

                    <button
                      onClick={() => handleSubmit(onSubmit)()}
                      className="w-full bg-blue-500 text-white py-2 px-4 rounded-md hover:bg-blue-600"
                    >
                      Criar Nova Coleta
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
